var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "grid-panel",
    { attrs: { "panel-header": _vm.utilizationHeader, loading: _vm.loading } },
    [
      _c("div", { staticClass: "utilization-panel" }, [
        _c(
          "div",
          { staticClass: "utilization-kpi" },
          [
            _vm.hasNoData
              ? _c("div", { staticClass: "no-data-message" }, [
                  _vm._v("\n        No Data To Display\n      "),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.hasNoData
              ? _c(
                  "v-progress-circular",
                  {
                    attrs: {
                      value: _vm.utilizationValue,
                      color: _vm.utilizationColor,
                      size: 144,
                      width: 10,
                    },
                  },
                  [
                    _c("div", { staticClass: "kpi" }, [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(_vm.utilizationText) },
                      }),
                    ]),
                  ]
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        !_vm.hasNoData
          ? _c("div", { staticClass: "countText" }, [
              _c("div", [
                _vm._v(
                  "(" +
                    _vm._s(
                      Intl.NumberFormat("en-US").format(_vm.utilizationCount)
                    ) +
                    " of " +
                    _vm._s(
                      Intl.NumberFormat("en-US").format(_vm.utilizationLimit)
                    ) +
                    ")"
                ),
              ]),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(_vm.metricName) + " Licenses Used")]),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }